export const termsConditionsInitialState: TermsConditionsState = {
    districtSaleContractAcceptanceRequired: false,
    checkAllTermsAndConditions: false,
};

/**
 * Modelo del State de la feature para terminos y condiciones
 */
export class TermsConditionsState {
    public districtSaleContractAcceptanceRequired: boolean;

    public checkAllTermsAndConditions: boolean;
}
